import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../utils';
import { cardContentStyling } from './styling';
export function CardContent({ children, className, padding, ...props }) {
    return (_jsx("div", { className: cn(cardContentStyling({ padding }), className), ...props, children: children }));
}
